import { useForm, Resolver } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface FormData {
  [key: string]: unknown;
}

export const useFormHandler = <T extends FormData>(
  validationSchema: yup.ObjectSchema<T>,
) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    control,
    trigger,
    watch,
  } = useForm<T>({
    resolver: yupResolver(validationSchema) as unknown as Resolver<T>,
  });

  return {
    register,
    handleSubmit,
    errors,
    reset,
    setValue,
    getValues,
    control,
    trigger,
    watch,
  };
};
